<template>
  <div class="top-bar">
    <div class="logo">
      <router-link to="/home">
        <svg viewBox="0 0 253 44">
          <use :xlink:href="`${logo}#logo`"></use>
        </svg>
      </router-link>
    </div>

    <div class="bites">
      <router-link class="user-icon" to="/einstellungen">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <!--! Font Awesome Free 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. -->
          <path
            d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
          />
        </svg>
      </router-link>
      <router-link to="/bites">
        <div class="value">{{ this.$store.state.bitePoints }}</div>
        <div class="name">bites</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Logo from "@/assets/logo.svg";

export default {
  name: "NavBar",
  data() {
    return {
      logo: Logo,
    };
  },
};
</script>

<style lang="scss" scoped>
@import url("@/assets/styles/_variables.scss");

.top-bar {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #ddd;
  padding: 0 30px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    height: auto;

    svg {
      height: 24px;
      width: auto;
    }
  }

  .bites {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: center;
    line-height: 1;

    a {
      text-decoration: none;
      color: inherit;
    }

    a.user-icon {
      width: 15px;

      svg {
        width: 100%;
        height: auto;
      }
    }

    a + a {
      margin-left: 20px;
    }
    .value {
      margin-bottom: 2px;
      font-size: 1.1rem;
      font-weight: 600;
      color: $primary;
    }
  }
}
</style>
